export const generalFindingTypeFiltersEnum = {
  immediate: 'Immediate',
  investigation: 'Investigation',
  noteAutomatic: 'NoteAutomatic',
  noteManual: 'NoteManual',
  dismissed: 'Dismissed',
};

const adminOnlyTypeFiltersEnum = {
  unclassified: 'Unclassified',
};

export const allFindingTypeFiltersEnum = {
  ...generalFindingTypeFiltersEnum,
  ...adminOnlyTypeFiltersEnum,
};

export default { allFindingTypeFiltersEnum, generalFindingTypeFiltersEnum };
